var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningTriangleUnfilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#warning-triangle-unfilled_svg__clip0_1011_4554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 9.75v3.75M10.706 3.75L2.456 18a1.5 1.5 0 001.294 2.25h16.5A1.5 1.5 0 0021.544 18l-8.25-14.25a1.49 1.49 0 00-2.588 0z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.7a1.05 1.05 0 100-2.1 1.05 1.05 0 000 2.1z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "warning-triangle-unfilled_svg__clip0_1011_4554"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

export default SvgWarningTriangleUnfilled;